export function isServerSide() {
  return typeof(window) === 'undefined' || window.navigator.userAgent === 'node';
}
